import _cloneDeep from 'lodash/cloneDeep';

export default {
  adminFeesResults: (state) => _cloneDeep(state.adminFeesResults),
};
